class BaseElement extends HTMLElement
{
  constructor () {
    super();

    this.safeEventListeners = [];
    this.safeWindowEventListeners = [];
    this.safeDocumentEventListeners = [];

    if (/complete|interactive|loaded/.test(document.readyState)) {
      setTimeout(this.init.bind(this), 1);
    } else {
      this.onDocumentLoaded(() => this.init());
    }

    this.debugger = makeDebugger();
  }

  // called on document loaded
  init () {}

  connectedCallback () {
    // Add event listeners again after DOM is moved
    this.safeEventListeners.forEach(event => {
      this.addEventListener(event.type, event.listener, event.options);
    });

    this.safeDocumentEventListeners.forEach(event => {
      document.addEventListener(event.type, event.listener, event.options);
    });

    this.safeWindowEventListeners.forEach(event => {
      window.addEventListener(event.type, event.listener, event.options);
    });
  }

  disconnectedCallback () {
    this.safeEventListeners.forEach(event => {
      this.removeEventListener(event.type, event.listener);
    });

    this.safeDocumentEventListeners.forEach(event => {
      document.removeEventListener(event.type, event.listener);
    });

    this.safeWindowEventListeners.forEach(event => {
      window.removeEventListener(event.type, event.listener);
    });
  }

  // Add event listener which will be removed after DOM is removed
  addSafeEventListener(type, listener, options) {
    this.safeEventListeners.push({
      type: type,
      listener: listener,
      options: options
    });

    this.addEventListener(type, listener, options);
  }

  // Add document event listener which will be removed after DOM is removed
  addSafeDocumentEventListener(type, listener, options) {
    this.safeDocumentEventListeners.push({
      type: type,
      listener: listener,
      options: options
    });

    document.addEventListener(type, listener, options);
  }

  // Add window event listener which will be removed after DOM is removed
  addSafeWindowEventListener(type, listener, options) {
    this.safeWindowEventListeners.push({
      type: type,
      listener: listener,
      options: options
    });

    window.addEventListener(type, listener, options);
  }

  onBroadcast (eventName, listener) {
    const wrapper = e => {
      listener.apply(null, [e.detail]);
    };

    this.addSafeDocumentEventListener(eventName, wrapper);
  }

  onDocumentLoaded (listener) {
    this.addSafeWindowEventListener('DOMContentLoaded', listener);
  }

  getSectionsToRender () {
    return [];
  }

  renderSections (sections) {
    this.getSectionsToRender().forEach((section => {
      const elementSection = document.getElementById(section.id)
        ? document.getElementById(section.id)
        : document.querySelector(section.id);

      if (!elementSection) {
        console.error('Section to render "' + section.id + '" not found', this);
        return;
      }

      const elementToReplace = elementSection.querySelector(section.selector) || elementSection;

      if (elementToReplace) {
        elementToReplace.innerHTML =
          this.getSectionInnerHTML(sections[section.section], section.selector);
      }
    }));
  }

  getSectionInnerHTML (html, selector) {
    const parser = new DOMParser()
      .parseFromString(html, 'text/html');

    if (!parser.querySelector(selector)) {
      console.error('Section selector "' + selector + '" is invalid', this);
    }

    return parser.querySelector(selector).innerHTML;
  }
}

class BaseDivElement extends HTMLElement
{
  constructor () {
    super();

    this.safeEventListeners = [];
    this.safeWindowEventListeners = [];
    this.safeDocumentEventListeners = [];

    if (/complete|interactive|loaded/.test(document.readyState)) {
      setTimeout(this.init.bind(this), 1);
    } else {
      this.onDocumentLoaded(() => this.init());
    }

    this.debugger = makeDebugger();
  }

  // called on document loaded
  init () {}

  disconnectedCallback () {
    this.safeEventListeners.forEach(event => {
      this.removeEventListener(event.type, event.listener);
    });

    this.safeDocumentEventListeners.forEach(event => {
      document.removeEventListener(event.type, event.listener);
    });

    this.safeWindowEventListeners.forEach(event => {
      window.removeEventListener(event.type, event.listener);
    });
  }

  // Add event listener which will be removed after DOM is removed
  addSafeEventListener(type, listener, options) {
    this.safeEventListeners.push({
      type: type,
      listener: listener
    });

    this.addEventListener(type, listener, options);
  }

  // Add document event listener which will be removed after DOM is removed
  addSafeDocumentEventListener(type, listener, options) {
    this.safeDocumentEventListeners.push({
      type: type,
      listener: listener
    });

    document.addEventListener(type, listener, options);
  }

  // Add window event listener which will be removed after DOM is removed
  addSafeWindowEventListener(type, listener, options) {
    this.safeWindowEventListeners.push({
      type: type,
      listener: listener
    });

    window.addEventListener(type, listener, options);
  }

  onBroadcast (eventName, listener) {
    const wrapper = e => {
      listener.apply(null, [e.detail]);
    };

    this.addSafeDocumentEventListener(eventName, wrapper);
  }

  onDocumentLoaded (listener) {
    this.addSafeWindowEventListener('DOMContentLoaded', listener);
  }

  getSectionsToRender () {
    return [];
  }

  renderSections (sections) {
    this.getSectionsToRender().forEach((section => {
      const elementSection = document.getElementById(section.id)
        ? document.getElementById(section.id)
        : document.querySelector(section.id);

      if (!elementSection) {
        console.error('Section to render "' + section.id + '" not found', this);
        return;
      }

      const elementToReplace = elementSection.querySelector(section.selector) || elementSection;

      if (elementToReplace) {
        elementToReplace.innerHTML =
          this.getSectionInnerHTML(sections[section.section], section.selector);
      }
    }));
  }

  getSectionInnerHTML (html, selector) {
    const parser = new DOMParser()
      .parseFromString(html, 'text/html');

    if (!parser.querySelector(selector)) {
      console.error('Section selector "' + selector + '" is invalid', this);
    }

    return parser.querySelector(selector).innerHTML;
  }
}

function broadcast (eventName, data) {
  document.dispatchEvent(new CustomEvent(eventName, {
    detail: data
  }));
}

function onBroadcast (eventName, listener) {
  document.addEventListener(eventName, e => {
    listener.apply(null, [e.detail]);
  });
}

class Events
{
  on (event, callback)
  {
    ('' + event).split(',').forEach(ev => {
      ev = ev.trim();

      if (typeof(this._onEvent) === 'undefined') {
        this._onEvent = [];
      }

      if (typeof(this._onEvent[ev]) === 'undefined') {
        this._onEvent[ev] = [];
      }

      this._onEvent[ev].push(callback.bind(this));
    });

    return this;
  }

  once (event, callback)
  {
    if (typeof(this._onEvent) === 'undefined') {
      this._onceEvent = [];
    }

    if (typeof(this._onceEvent[event]) === 'undefined') {
      this._onceEvent[event] = [];
    }

    this._onceEvent[event].push(callback.bind(this));

    return this;
  }

  emit (event, ...data)
  {
    if (typeof(this._onEvent) === 'undefined') {
      this._onEvent = [];
    }

    if (typeof(this._onceEvent) === 'undefined') {
      this._onceEvent = [];
    }

    if (event.indexOf('#') === 0) {
      var obj = event.substr(0, event.indexOf('-'));
      var prop = event.substr(event.indexOf('-') + 1);
      var id = prop.indexOf('-') > -1 ? prop.substr(prop.indexOf('-') + 1) : null;

      if (id) {
        prop = prop.substr(0, prop.indexOf('-'));
      }

      if (obj && prop && id) {
        if (typeof(this._onEvent[obj]) !== 'undefined') {
          for (var i = 0; i < this._onEvent[obj].length; i++) {
            if (typeof(this._onEvent[obj][i]) === 'function') {
              this._onEvent[obj][i](id, prop, ...data);
            }
          }
        }

        if (typeof(this._onceEvent[obj]) !== 'undefined') {
          while (this._onceEvent[obj].length > 0) {
            var ev = this._onceEvent[obj].shift();

            if (typeof(ev) === 'function') {
              ev(id, prop, ...data);
            }
          }
        }

        return;
      }

      if (typeof(this._onEvent[obj]) !== 'undefined') {
        for (var i = 0; i < this._onEvent[obj].length; i++) {
          if (typeof(this._onEvent[obj][i]) === 'function') {
            this._onEvent[obj][i](prop, null, ...data);
          }
        }
      }

      if (typeof(this._onceEvent[obj]) !== 'undefined') {
        while (this._onceEvent[obj].length > 0) {
          var ev = this._onceEvent[obj].shift();

          if (typeof(ev) === 'function') {
            ev(prop, null, ...data);
          }
        }
      }

      return;
    }

    if (typeof(this._onEvent[event]) !== 'undefined') {
      for (var i = 0; i < this._onEvent[event].length; i++) {
        if (typeof(this._onEvent[event][i]) === 'function') {
          this._onEvent[event][i](...data);
        }
      }
    }

    if (typeof(this._onceEvent[event]) !== 'undefined') {
      while (this._onceEvent[event].length > 0) {
        var ev = this._onceEvent[event].shift();

        if (typeof(ev) === 'function') {
          ev(...data);
        }
      }
    }

    return this;
  }

  unbind (event)
  {

    if (typeof this._onEvent !== 'undefined') {
      this._onEvent[event] = [];
    }
    if (typeof this._onceEvent !== 'undefined') {
      this._onceEvent[event] = [];
    }

    return this;
  }
}

// One debug switch for the whole frontend. `?debug` in any URL turns it on
// and persists it in a cookie so it survives reloads, internal navigation and
// checkout round-trips; `?debug=0` (or false/off) turns it off again. Support
// can therefore send a customer a plain `?debug` link. `#debug` and the
// legacy `clinic_debug` cookie keep working as aliases.
(function initDebugMode() {
  const cookieEnabled = document.cookie.split(';').some(part => {
    const cookie = part.trim();

    return cookie === 'debug=true' || cookie === 'clinic_debug=true';
  });

  let enabled = cookieEnabled || window.location.hash === '#debug';

  const params = new URLSearchParams(window.location.search);

  if (params.has('debug')) {
    if (['0', 'false', 'off', 'no'].indexOf(('' + params.get('debug')).toLowerCase()) !== -1) {
      enabled = false;
      document.cookie = 'debug=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
      document.cookie = 'clinic_debug=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
    } else {
      enabled = true;
      document.cookie = 'debug=true; path=/; max-age=604800';
    }
  }

  window.__debugMode = enabled;
})();

function isDebugMode() {
  return window.__debugMode === true;
}

// Deprecated alias — the hash-only check merged into isDebugMode().
function isDebuggerMode() {
  return isDebugMode();
}

function makeDebugger() {
  if (isDebuggerMode()) {
    const entry = ['🪳 %c[Debugger]', 'background:#ff9800;color:white'];
    return {
      log: console.log.bind(window.console, ...entry),
      debug: console.debug.bind(window.console, ...entry),
      info: console.info.bind(window.console, ...entry),
      error: console.error.bind(window.console, ...entry),
      active: true,
    };
  }

  // Keep the same method surface as the active debugger so a call site never
  // throws only in one of the two modes.
  return { log: () => {}, debug: () => {}, error: () => {}, info: () => {}, active: false };
}